import AddPlannableForm from "./componets/add-plannables-form";
import { Button } from "ui/components/button";
import React from "react";
import useTimesheetPlanning from "./hooks";
import WeekPicker from "@/modules/timesheet/plan/componets/week-picker";

import { PlanningTable } from "@/modules/timesheet/plan/componets/table";
import { EvtHeader } from "components/header";
import ButtonWithLoading from "@/components/button-with-loading";
import HeaderPortal from "components/portal/header-portal";

const TimesheetPlanning = () => {
  const {
    timesheet,
    getWeekData,
    handleUserChange,
    handleDateChange,
    handleHourChange,
    currentDate,
    selectedUser,
    loading,
    updateLoading,
    saveTimesheet,
    handleAddPlannable,
    handleDeletePlannable,
    getPlannableId,
    getPlannableTotal,
    getDayTotal,
    getWeekTotal,
    hasUnsavedChanges,
  } = useTimesheetPlanning();

  const weekData = getWeekData();

  return (
    <div className="p-4 flex-1 overflow-auto">
      <EvtHeader title="Plan Hours">
        <WeekPicker currentDate={currentDate} onWeekChange={handleDateChange} />
      </EvtHeader>
      <HeaderPortal>
        <ButtonWithLoading
          isLoading={updateLoading}
          onClick={saveTimesheet}
          variant="default"
          disabled={!hasUnsavedChanges}
        >
          Save
        </ButtonWithLoading>
      </HeaderPortal>
      <PlanningTable
        timesheet={timesheet}
        selectedUser={selectedUser}
        loading={loading}
        getWeekTotal={getWeekTotal}
        getDayTotal={getDayTotal}
        weekData={weekData}
        getPlannableTotal={getPlannableTotal}
        getPlannableId={getPlannableId}
        handleHourChange={handleHourChange}
        handleDeletePlannable={handleDeletePlannable}
        handleUserChange={handleUserChange}
      />
      <AddPlannableForm
        onSave={handleAddPlannable}
        selectedUser={selectedUser}
        weekStartDate={weekData[0]?.fullDate}
        weekEndDate={weekData[6]?.fullDate}
      />
    </div>
  );
};

export default TimesheetPlanning;
